import PropTypes from "prop-types";

import { activePollProptype } from "@/view/PollContainer/PollProptypes";
import InteractivePollOption from "./InteractivePollOption";
import {
  staticPollOptionsCss,
  staticPollOptionCss,
  interactivePollOptionsCss,
} from "./PollOptions.style";
import PollOptionWithResults from "./PollOptionWithResults";
import StaticPollOption from "./StaticPollOption";

const propTypes = {
  activePoll: activePollProptype.isRequired,
  isInteractive: PropTypes.bool,
  setSelectedValue: PropTypes.func,
  userId: PropTypes.string,
};

const PollOptions = ({
  activePoll,
  isInteractive,
  setSelectedValue,
  userId,
}) => {
  const { can_see_results: canSeeResults, data: pollData } = activePoll;

  if (isInteractive) {
    return (
      <div css={interactivePollOptionsCss}>
        {pollData?.choices?.map((choice, index) => (
          <InteractivePollOption
            key={choice.text}
            choice={choice}
            dataQaSelector={`student-poll-choice-item-${index}`}
            setSelectedValue={setSelectedValue}
          />
        ))}
      </div>
    );
  }

  const renderStaticPollOption = (choice) => {
    if (canSeeResults) {
      return (
        <PollOptionWithResults
          choice={choice}
          pollData={pollData}
          userId={userId}
        />
      );
    }

    return <StaticPollOption choice={choice} />;
  };

  return (
    <ul
      aria-label={canSeeResults ? "Student responses" : "Poll choices"}
      css={staticPollOptionsCss}
      role="list"
    >
      {pollData?.choices?.map((choice) => (
        <li key={choice.text} css={staticPollOptionCss}>
          {renderStaticPollOption(choice)}
        </li>
      ))}
    </ul>
  );
};

PollOptions.propTypes = propTypes;

export default PollOptions;
